// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1hLDk","productName":"Table_productName__1dOpo"};